module.exports = __webpack_public_path__ + "img/brunei-darussalam.2ae22c50.svg";